export const ENDPOINT = {
  LOGIN: '/login',
  GOOGLE_AUTH: '/auth/google',
  MICROSOFT_AUTH: '/auth/microsoft',
};
